module.exports = __webpack_public_path__ + "static/media/TicketAnalyticsIcon.c5a6b880.png";